import React, { Component } from 'react'
//import 'antd/dist/antd.css';
import { Table, Input, Select, Button, Space, PageHeader, Popconfirm, Breadcrumb,Tag, Drawer, Modal, Form, Pagination   } from 'antd';
import Highlighter from 'react-highlight-words';
import { CheckCircleOutlined, DeleteOutlined, EditOutlined, EyeOutlined, KeyOutlined, PlusCircleFilled, SearchOutlined,SettingOutlined,StopOutlined } from '@ant-design/icons';
import { Content } from 'antd/lib/layout/layout';
import { getUsers, createUser, updateUser,deleteUser, updateAuth, updateUserPassword } from "../../action/user";
import { Link } from 'react-router-dom';
import history from '../../history';
import { connect } from 'react-redux';
import { useState } from 'react';
import { useEffect } from 'react';
import { renderCheckbox, renderInput } from '../../components/form/form';
// import { renderTextField } from '../../../component/form/form';
// import Remarks from '../../../component/remark';
// import ModalForm from './modalForm';
// import EditModalForm from './editModalForm';
const Search = Input.Search;

const { Option } = Select;
// const Select = Input.Search;
const UserList = ({ getUsers, updateUser,deleteUser, createUser, updateAuth, updateUserPassword}) => {
  const [ID, setID] = useState('')
  const [page, setPage] = useState(1)
  const [data, setData] = useState(null)
  const [searchText, setSearchText] = useState('')
  const [searchedColumn, setSearchedColumn] = useState('')
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isPassModalOpen, setIsPassModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [cform] = Form.useForm();
  const [pform] = Form.useForm();

  const getData = async () => {
    const res = await getUsers(page)
    setData(res);
  }
  useEffect(() => {
    getData()
  }, [])

  const showModal = () => {
    setIsCreateModalOpen(true);
  };

  const handleOk = () => {
    setIsCreateModalOpen(false);
  };

  const handleCancel = () => {
    setIsCreateModalOpen(false);
  };

  const handleEdit = async (item) => {
    setID(item?.user_id)
    setIsEditModalOpen(true);
    form.setFieldsValue({
      name: item?.name,
      mobile_number: item?.mobile_number,
      email: item?.email,
      access: item?.access,
      authenticated: item?.authenticated.toString(),
    });
  }
  const handleStatus = async (item, val) => {
    const res = await updateAuth(item?.user_id, val )
    if(res === 201){
      getData();
    };
  }
  const handlePass = async (val) => {
    const res = await updateUserPassword(ID, val )
    if(res === 201){
      getData();
      pform.resetFields();
      setIsPassModalOpen(false)
    };
  }
  
  const handleDelete = async (item) => {
    const res =  await deleteUser(item?.user_id);
    if(res === 201){
      getData();
    };
  }
  const getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Search
          // ref={node => {
          //   searchInput = node;
          // }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        // setTimeout(() => searchInput.select(), 100);
      }
    },
    render: text =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = clearFilters => {
    clearFilters();
      setSearchText('');
  };

  const createData = (code, name, mobile_number, email, authenticated, action) => {
    return {code, name, mobile_number, email, authenticated, action};
  };

  const columns = [
    {
      title: 'SL',
      dataIndex: 'code',
      key: 'code',
      width: '10%',
      ...getColumnSearchProps('code'),
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: '20%',
      ...getColumnSearchProps('name'),
    },
    {
      title: 'Mobile Number',
      dataIndex: 'mobile_number',
      key: 'mobile_number',
      width: '20%',
      ...getColumnSearchProps('mobile_number'),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      width: '20%',
      ...getColumnSearchProps('email'),
    },
    {
      title: 'Status',
      dataIndex: 'authenticated',
      key: 'authenticated',
      width: '20%',
      ...getColumnSearchProps('authenticated'),
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      width: '20%',
    },
  ];

  const rows = [
    data
      ? data.map((item, key) => createData(
        key + 1, 
        item?.name, 
        item?.mobile_number, 
        item?.email, 
        item?.authenticated ?
        <>
          Active &nbsp;
          <Button size="small" type="danger" icon={<EditOutlined  />} onClick={() => handleStatus(item, 'false')}>Change</Button> &nbsp;
        </>   : 
        <>
         Inactive &nbsp;
        <Button size="small" type="primary" icon={<EditOutlined  />} onClick={() => handleStatus(item, 'true')}>Change</Button> &nbsp;
        </>, 
        <>
          <Button size="small" type="primary" icon={<EditOutlined  />} onClick={() => handleEdit(item)}>Edit</Button> &nbsp;
          <Button size="small" type="danger" icon={<DeleteOutlined  />} onClick={() => handleDelete(item)}>Delete</Button> <br /><br />
          <Button size="small" type="primary" icon={<KeyOutlined />} onClick={ () => { setID(item?.user_id) ; setIsPassModalOpen(true)}}>Change Password</Button> &nbsp;
        </>
        ))
      : "",
  ];

  const onFinish = async (values) => {
    const res = await createUser(values, ID);
    if(res ===  200){
      getData();
      setIsCreateModalOpen(false);
      cform.resetFields();
    }
  };

  const onFinishEdit = async (values) => {
    console.log(ID);
    const res = await updateUser(values, ID);
    if(res ===  201){
      getData();
      setIsEditModalOpen(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  const layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 16 },
  };
  const tailLayout = {
    wrapperCol: { offset: 4, span: 16 },
  };
  
  const handlePagination = async (e) => {
    setPage(e);
    const res = await getUsers(e)
    setData(res);
  }

  return ( 
    <Content style={{ margin: '0 16px' }}>

      <br />
      <PageHeader
        ghost={false}
        title="User"
        subTitle="User Management"
        extra={[
          <Button key="1"  type="primary" icon={<PlusCircleFilled />} onClick = { showModal}>Create New
          </Button>,
        ]}
      >
      </PageHeader>

      <Table columns={columns} pagination={false} dataSource={rows[0]} scroll={{ x: 1000 }} sticky/>
      <br />
      <Pagination defaultCurrent={1} total={data?.total} onChange={(e) => { handlePagination(e); }} />
      
      <Modal 
        title="Add User" 
        visible={isCreateModalOpen} 
        onOk={handleOk} 
        onCancel={handleCancel} 
        width={800}
        footer={null}
      >
        <Form
          {...layout}
          name="basic"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          form={cform}
        >
              
          {renderInput('name', 'name', [
              { required: true, message: 'This field is required!' },
            ])
          }
          {renderInput('email', 'Email', [
              { required: true, message: 'This field is required!' },
            ])
          }
          {renderInput('mobile_number', 'Mobile Number', [
              { required: true, message: 'This field is required!' },
            ])
          }
          {renderInput('password', 'Password', [
              { required: true, message: 'This field is required!' },
              '', 'password'
            ])
          }
          
          <Form.Item
              label="Status"
              name="authenticated"
              rules={[{ required: true, message: 'Required' }]}
          >
              <Select  >
                <Option value="true">Active</Option>
                <Option value="false">Inactive</Option>
              </Select>
          </Form.Item>
          <Form.Item
              label="Access"
              name="access"
              rules={[{ required: true, message: 'Required' }]}
          >
              <Select  >
                <Option value="a">All</Option>
                <Option value="r">Read</Option>
                <Option value="w">Write</Option>
              </Select>
          </Form.Item>

          <Form.Item {...tailLayout}> 
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
                
        </Form>
      </Modal>
      
      <Modal 
        title="Edit User" 
        visible={isEditModalOpen} 
        onOk={() => setIsEditModalOpen(false)} 
        onCancel={() => setIsEditModalOpen(false)} 
        width={800}
        footer={null}
        form={form}
      >
        <Form
          {...layout}
          name="Edit "
          initialValues={{ remember: true }}
          onFinish={onFinishEdit}
          onFinishFailed={onFinishFailed}
          form={form}
        >
              
        {renderInput('name', 'name', [
            { required: true, message: 'This field is required!' },
          ])
        }
        {renderInput('email', 'Email', [
            { required: true, message: 'This field is required!' },
          ])
        }
        {renderInput('mobile_number', 'Mobile Number', [
            { required: true, message: 'This field is required!' },
          ])
        }
        
        <Form.Item
            label="Status"
            name="authenticated"
            rules={[{ required: true, message: 'Required' }]}
        >
            <Select  >
              <Option value="true">Active</Option>
              <Option value="false">Inactive</Option>
            </Select>
        </Form.Item>
        <Form.Item
            label="Access"
            name="access"
            rules={[{ required: true, message: 'Required' }]}
        >
            <Select  >
              <Option value="a">All</Option>
              <Option value="r">Read</Option>
              <Option value="w">Write</Option>
            </Select>
        </Form.Item>
          <Form.Item {...tailLayout}> 
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
                
        </Form>
      </Modal>
      
      <Modal 
        title="Change Password" 
        visible={isPassModalOpen} 
        onOk={() => setIsPassModalOpen(false)} 
        onCancel={() => setIsPassModalOpen(false)} 
        width={800}
        footer={null}
      >
        <Form
          {...layout}
          name="basic"
          initialValues={{ remember: true }}
          onFinish={handlePass}
          onFinishFailed={onFinishFailed}
          form={pform}
        >
         
          {renderInput('password', 'New Password', [
              { required: true, message: 'This field is required!' },
            ])
          }
          {renderInput('confirm_password', 'Confirm Password', [
              { required: true, message: 'This field is required!' },
            ])
          }
          <Form.Item {...tailLayout}> 
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
                
        </Form>
      </Modal>
    </Content>
   );
}
 
export default connect(null, {getUsers, createUser, updateUser, deleteUser, updateAuth, updateUserPassword})(UserList);